import { render, staticRenderFns } from "./CardUp.vue?vue&type=template&id=7c1db9cf&scoped=true&"
import script from "./CardUp.vue?vue&type=script&lang=js&"
export * from "./CardUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1db9cf",
  null
  
)

export default component.exports